import { Locale } from 'date-fns';
import { ru, enUS, es, et } from 'date-fns/locale';

export const getDateFnsLocale = (language: string): Locale => {
  switch (language) {
    case 'en':
      return enUS;
    case 'es':
      return es;
    case 'et':
      return et;
    case 'ru':
    default:
      return ru;
  }
};
